import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PPIExpenseFormComponent from './form-component';
import * as actions from '../../../../actions';
import PPIExpenseService from '../../../../service/sfp/ppi-expense-service';

class ExpenseFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: undefined, 
			submitting: false,
			name: ""
		};
	}

	componentDidMount() {
		if (this.props.expense) this.setState({name: this.props.expense.name})
	}

	render() {
		return (
			<PPIExpenseFormComponent
				name					= {this.state.name}
				delete				= {this.props.delete}
				onNameChange	= {(e) => {e.constructor === String ?this.setState({name: e}):this.setState({name: e.target.value})}}
				expense				= {this.props.expense}
				onSubmit      = {this._handleSubmit}
				submitting    = {this.state.submitting}
			/>
		)
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true })

		const ppi_expense = {
			name: event.target.name.value,
			ppi: this.props.ppi.id
		}

		if (this.props.delete) {
			PPIExpenseService.deletePPIExpense(this.props.expense)
				.then(this._resolveDeleteExpense.bind(this, event), this._rejectDeleteExpense)
		} else if (this.props.expense) {
			PPIExpenseService.updatePPIExpense(this.props.expense.id, ppi_expense)
				.then(this._resolveUpdateExpense.bind(this, event), this._rejectUpdateExpense)
		} else {
			PPIExpenseService.createPPIExpense(ppi_expense)
				.then(this._resolveCreateExpense.bind(this, event), this._rejectCreateExpense)
		}
	}

	_rejectCreateExpense = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveCreateExpense = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onCreated(response)
		})
	}

	_rejectUpdateExpense = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveUpdateExpense = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onUpdated(response)
		})
	}

	_rejectDeleteExpense = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveDeleteExpense = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onDeleted(response)
		})
	}



}

const mapDispatchToProps = dispatch => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(null, mapDispatchToProps)(ExpenseFormContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/expenses/form-container.js